let view = null;

export default {
	namespace: 'template-courses',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: CoursesView } = await import(
			/* webpackChunkName: "courses-view" */ '../../templates/CoursesView'
		);
		view = new CoursesView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
